// Exporta todas as questões organizadas por Disciplina/Assunto
// LAZY LOADING - questões são carregadas sob demanda

// ==================== MÚLTIPLOS ASSUNTOS POR QUESTÃO ====================
// Uma questão pode pertencer a MAIS DE UM assunto (ex.: um item rotulado como
// "Interpretação de Texto" também conta como "Compreensão de textos" do edital).
// Duas formas de marcar:
//   1) campo opcional `assuntos: [...]` na própria questão (tem prioridade);
//   2) mapa de equivalência abaixo: o `assunto` (string) é EXPANDIDO para os
//      tópicos do edital equivalentes, sem precisar editar cada questão.
// O `assunto` (singular) continua sendo o rótulo PRINCIPAL exibido (badge).
const ASSUNTO_TAMBEM = {
    // Português — pontes rótulo-informal → termo do edital
    'Interpretação de Texto': ['Compreensão de textos'],
    'Regência verbal': ['Regência verbal e nominal'],
    'Colocação pronominal': ['Colocação dos pronomes oblíquos átonos'],
    'Sintaxe e pontuação': ['Sintaxe da oração e do período', 'Emprego dos sinais de pontuação'],
    'Concordância Verbal': ['Concordância verbal', 'Concordância verbal e nominal'],
    'Concordância verbal': ['Concordância verbal e nominal'],
    'Concordância nominal': ['Concordância verbal e nominal'],
};

// ==================== NORMALIZAÇÃO DE ASSUNTOS ====================
// Como as questões vieram de várias provas, o MESMO assunto foi rotulado de
// formas diferentes. Este mapa unifica os rótulos variantes num nome CANÔNICO
// por disciplina (não toca em Português, cujos 21 assuntos são padrão fixo).
// Aplicado em filtro, estatísticas E exibição (badge) — fonte única da verdade.
const ASSUNTO_CANONICO = {
    // ----- Matemática Financeira / Raciocínio Lógico-Matemático -----
    'Juros Compostos': 'Juros compostos',
    'Juros compostos (taxas equivalentes)': 'Juros compostos',
    'Juros compostos (saldo devedor)': 'Juros compostos',
    'Juros compostos (taxas)': 'Juros compostos',
    'Juros compostos (equivalência)': 'Juros compostos',
    'Juros compostos (taxa efetiva)': 'Juros compostos',
    // ----- Matemática -----
    'Porcentagem (leitura de gráfico)': 'Porcentagem',
    'Frações e porcentagem': 'Porcentagem',
    'Conjuntos e porcentagem': 'Conjuntos',
    'Resto da divisão (função MOD)': 'Divisibilidade',
    'Divisibilidade e resto': 'Divisibilidade',
    'Frações e divisão proporcional': 'Divisão proporcional',
    'Frações e razões': 'Razão e proporção',
    'Potências e notação científica': 'Potências',
    'Potências e expressões': 'Potências',
    'Sequências e padrões': 'Sequências',
    'Raciocínio lógico (problema)': 'Raciocínio lógico',
    'Raciocínio lógico (potências)': 'Raciocínio lógico',
    'Sistemas / raciocínio': 'Raciocínio lógico',
    'Proporção / sistemas': 'Sistemas lineares',
    'Desconto comercial (por fora)': 'Desconto comercial',
    // ----- Conhecimentos Bancários -----
    'Prevenção à lavagem de dinheiro (Lei 9.613/1998)': 'Prevenção à lavagem de dinheiro',
    'Lavagem de dinheiro: etapas': 'Prevenção à lavagem de dinheiro',
    'Prevenção à lavagem (Circular Bacen 3.461/2009)': 'Prevenção à lavagem de dinheiro',
    'Prevenção à lavagem de dinheiro (COAF)': 'Prevenção à lavagem de dinheiro',
    'Mercado de câmbio': 'Câmbio',
    'Câmbio e fluxo de capitais': 'Câmbio',
    'Câmbio e política monetária': 'Câmbio',
    'Política monetária (COPOM)': 'Política monetária',
    'Copom / política monetária': 'Política monetária',
    'Liquidez / política monetária': 'Política monetária',
    'Mercado de capitais (Cetip)': 'Mercado de capitais',
    'CVM / mercado de capitais': 'Mercado de capitais',
    'Mercado de capitais (governança)': 'Mercado de capitais',
    'Sistema Financeiro Nacional (CMN)': 'Sistema Financeiro Nacional',
    'Garantias: alienação fiduciária': 'Garantias',
    'Garantias (alienação fiduciária)': 'Garantias',
    'Garantias (penhor mercantil)': 'Garantias',
    'Garantias do SFN (FGC)': 'Garantias',
    'Produtos bancários (capitalização)': 'Produtos bancários',
    'Produtos bancários (renda fixa)': 'Produtos bancários',
    // ----- Informática -----
    'MS Excel 2013': 'MS Excel',
    'Planilhas': 'MS Excel',
    'MS Windows 7': 'MS Windows',
    'MS PowerPoint 2010': 'MS PowerPoint',
    'Apresentações': 'MS PowerPoint',
    'Editores de texto': 'MS Word',
    'Segurança (Windows)': 'Segurança da informação',
    'Segurança da informação (criptografia)': 'Segurança da informação',
    'Navegador (Internet Explorer)': 'Navegadores',
    'Internet e navegadores': 'Navegadores',
    'Internet e redes sociais': 'Internet',
    'Internet e protocolos': 'Internet',
    'Internet e pesquisa': 'Internet',
    'Ferramentas colaborativas (Teams)': 'Ferramentas colaborativas',
    'Ferramentas colaborativas (Wiki)': 'Ferramentas colaborativas',
    // ----- Atendimento -----
    'Ouvidoria (Resolução CMN 4.433)': 'Ouvidoria',
    'Resolução CMN 3.694 (SAC)': 'Resolução CMN 3.694',
    'Valor para o cliente (proposta de valor)': 'Valor percebido pelo cliente',
    'Marketing de serviços (pesquisa)': 'Marketing de serviços',
    'Canais de comunicação / telemarketing': 'Telemarketing',
    // ----- Técnicas de Vendas -----
    'Composto de marketing (4 Ps) — Praça': 'Composto de marketing (4 Ps)',
    // ----- Cultura Organizacional -----
    'Código de Ética / conflito de interesses': 'Código de Ética',
    'Valores e cultura': 'Cultura organizacional',
    'Cultura adaptativa': 'Cultura organizacional',
};

/** Devolve o nome canônico de um assunto (ou ele mesmo, se já for canônico). */
export const getCanonicalAssunto = (a) => (a && ASSUNTO_CANONICO[a]) || a;

// ==================== CATEGORIA (tipo de exame) ====================
// Lista ÚNICA dos exames que o UniQuest cobre — é o que o seletor da tela de
// filtro mostra e o que o card "Resolva Questões" da Home promete
// (2026-08-29: ENADE · OAB · ENAMED). Mudar aqui muda nos dois lugares.
//
// ⚠️ `categoria` é CHAVE DE DADOS, não só rótulo: `getQuestionsStats` e o
// filtro comparam por igualdade de string. Questão sem `categoria` cai no
// padrão. Hoje NENHUMA questão do acervo tem `categoria` explícita (todas as
// 352 são de concurso do Banco do Brasil), então TODAS aparecem sob o padrão.
// Enquanto o ENADE não for importado (docs/handoff-importacao-questoes-enade.md),
// o aluno que escolher "ENADE" vai ver questões de concurso. Ao importar, marcar
// cada questão com `categoria: 'ENADE'` etc. e reavaliar o padrão.
export const CATEGORIAS = ['ENADE', 'OAB', 'ENAMED'];

// ⚠️ O PADRÃO FICA DE FORA DE `CATEGORIAS`, DE PROPÓSITO.
// `categoria` é CHAVE DE DADOS: o filtro compara por igualdade de string e
// questão SEM o campo cai aqui. As 352 questões do acervo (provas do Banco do
// Brasil) não têm `categoria`, então caem em 'Concursos Públicos' — que não é
// opção do seletor e portanto NÃO se mistura com ENADE/OAB/ENAMED.
//
// Entre 29 e 31/08 este valor foi `CATEGORIAS[0]` (= 'ENADE') para a tela não
// abrir vazia antes da importação. O efeito era prova de banco aparecendo sob
// "ENADE" — corrigido aqui: separação correta vale mais que tela cheia.
//
// Ao importar uma prova nova, marcar `categoria` explicitamente no helper `Q()`
// do arquivo (ex.: `categoria: 'ENADE'`). Sem isso ela some do seletor.
export const CATEGORIA_PADRAO = 'Concursos Públicos';
export const getQuestionCategoria = (q) => q?.categoria || CATEGORIA_PADRAO;

/**
 * Retorna TODOS os assuntos de uma questão (para filtro e estatísticas):
 * o assunto principal NORMALIZADO + os de `assuntos` (se houver) + expansões do mapa.
 */
export const getQuestionAssuntos = (q) => {
    const baseRaw = Array.isArray(q.assuntos) && q.assuntos.length
        ? q.assuntos
        : (q.assunto ? [q.assunto] : []);
    const base = baseRaw.map(getCanonicalAssunto);
    const set = new Set(base);
    base.forEach(a => (ASSUNTO_TAMBEM[a] || []).forEach(extra => set.add(extra)));
    return [...set];
};

// ==================== CACHE EM MEMÓRIA ====================
let cachedAllQuestions = null;

// ==================== FUNÇÕES DE CARREGAMENTO LAZY ====================

// Carrega portugues_crase.json sob demanda
const loadPortuguesCrase = async () => {
    const data = (await import('./portugues_crase.json')).default;
    return data;
};

// Carrega todas as questões de bancas sob demanda
const loadBancasQuestions = async () => {
    const [cespe, fcc, cesgranrio, vendas, bbEscriturario2018, bbEscriturario2015, bbEscriturario2013Fcc, bbEscriturario2011Fcc, bbEscriturario2010, bbEscriturario2009Cespe, bbAgenteComercial2022, bbAgenteComercial2021, enade2025Direito] = await Promise.all([
        import('../bancas/cespe.json').then(m => m.default),
        import('../bancas/fcc.json').then(m => m.default),
        import('../bancas/cesgranrio.json').then(m => m.default),
        import('../bancas/vendas_negocios.json').then(m => m.default),
        import('../bancas/bb_escriturario_2018.js').then(m => m.default),
        import('../bancas/bb_escriturario_2015.js').then(m => m.default),
        import('../bancas/bb_escriturario_2013_fcc.js').then(m => m.default),
        import('../bancas/bb_escriturario_2011_fcc.js').then(m => m.default),
        import('../bancas/bb_escriturario_2010.js').then(m => m.default),
        import('../bancas/bb_escriturario_2009_cespe.js').then(m => m.default),
        import('../bancas/bb_agente_comercial_2022.js').then(m => m.default),
        import('../bancas/bb_agente_comercial_2021.js').then(m => m.default),
        import('../bancas/inep_enade_2025_direito.js').then(m => m.default),
    ]);
    return [...cespe, ...fcc, ...cesgranrio, ...vendas, ...bbEscriturario2018, ...bbEscriturario2015, ...bbEscriturario2013Fcc, ...bbEscriturario2011Fcc, ...bbEscriturario2010, ...bbEscriturario2009Cespe, ...bbAgenteComercial2022, ...bbAgenteComercial2021, ...enade2025Direito];
};

// ==================== DISCIPLINAS ====================
export const DISCIPLINAS = [
    {
        id: 'portugues',
        name: 'Português',
        icon: '📝',
        color: '#3B82F6',
        assuntos: ['Crase', 'Concordância verbal e nominal', 'Regência', 'Pontuação', 'Interpretação de Texto'],
    },
    {
        id: 'direito_administrativo',
        name: 'Direito Administrativo',
        icon: '🏛️',
        color: '#10B981',
        assuntos: ['Atos Administrativos', 'Licitações', 'Contratos'],
    },
    {
        id: 'matematica',
        name: 'Matemática',
        icon: '🔢',
        color: '#F59E0B',
        assuntos: ['Porcentagem', 'Proporção', 'Juros'],
    },
    {
        id: 'matematica_financeira',
        name: 'Matemática Financeira',
        icon: '💰',
        color: '#10B981',
        assuntos: ['Juros Simples', 'Juros Compostos', 'Desconto'],
    },
    {
        id: 'vendas_negociacoes',
        name: 'Vendas e Negociações',
        icon: '🤝',
        color: '#8B5CF6',
        assuntos: ['Atendimento', 'Técnicas de Vendas', 'Negociação'],
    },
    {
        id: 'informatica',
        name: 'Informática',
        icon: '💻',
        color: '#EC4899',
        assuntos: ['Windows', 'Word', 'Excel', 'Internet'],
    },
];

// ==================== BANCAS ====================
export const BANCAS = [
    { id: 'todas', name: 'Todas as Bancas', icon: '📋', color: '#6B7280' },
    { id: 'vunesp', name: 'VUNESP', icon: '📚', color: '#F59E0B' },
    { id: 'fgv', name: 'FGV', icon: '🏛️', color: '#8B5CF6' },
    { id: 'cesgranrio', name: 'CESGRANRIO', icon: '🎯', color: '#3B82F6' },
    { id: 'fcc', name: 'FCC', icon: '📝', color: '#10B981' },
    { id: 'cespe', name: 'CESPE/CEBRASPE', icon: '🎯', color: '#EF4444' },
    { id: 'objetiva', name: 'OBJETIVA', icon: '✅', color: '#06B6D4' },
    { id: 'fama', name: 'FAMA', icon: '📖', color: '#84CC16' },
    { id: 'idesg', name: 'IDESG', icon: '🔍', color: '#A855F7' },
    { id: 'ameosc', name: 'AMEOSC', icon: '📋', color: '#14B8A6' },
    { id: 'avanca_sp', name: 'Avança SP', icon: '🚀', color: '#F97316' },
    { id: 'evo', name: 'EVO Concursos', icon: '⭐', color: '#FBBF24' },
];

// ==================== FUNÇÃO PRINCIPAL - LAZY LOADING ====================

/**
 * Obtém TODAS as questões (LAZY LOADING com cache)
 * Combina questões de portugues_crase + todas as bancas
 * @returns {Promise<Array>} - Array com todas as questões
 */
export const getAllQuestions = async () => {
    if (cachedAllQuestions) return cachedAllQuestions;

    const [portugues, bancas] = await Promise.all([
        loadPortuguesCrase(),
        loadBancasQuestions(),
    ]);

    cachedAllQuestions = [...portugues, ...bancas];
    return cachedAllQuestions;
};

// ==================== FUNÇÕES DE FILTRO (ASYNC) ====================

/**
 * Obtém questões por disciplina
 */
export const getQuestionsByDisciplina = async (disciplina) => {
    const allQuestions = await getAllQuestions();
    if (!disciplina || disciplina === 'todas') return allQuestions;
    return allQuestions.filter(q =>
        q.disciplina?.toLowerCase().includes(disciplina.toLowerCase())
    );
};

/**
 * Obtém questões por assunto
 */
export const getQuestionsByAssunto = async (assunto) => {
    const allQuestions = await getAllQuestions();
    if (!assunto || assunto === 'todos') return allQuestions;
    return allQuestions.filter(q =>
        q.assunto?.toLowerCase().includes(assunto.toLowerCase())
    );
};

/**
 * Obtém questões por banca
 */
export const getQuestionsByBanca = async (banca) => {
    const allQuestions = await getAllQuestions();
    if (!banca || banca === 'todas') return allQuestions;
    return allQuestions.filter(q =>
        q.banca?.toLowerCase().includes(banca.toLowerCase())
    );
};

/**
 * Obtém questões por ano
 */
export const getQuestionsByAno = async (ano) => {
    const allQuestions = await getAllQuestions();
    if (!ano || ano === 'todos') return allQuestions;
    return allQuestions.filter(q => q.ano === ano || String(q.ano) === String(ano));
};

/**
 * Filtro combinado (ASYNC).
 * Cada filtro aceita um VALOR ÚNICO (string) ou uma LISTA (array) de valores.
 * Regra: OR dentro da mesma categoria (vale qualquer um dos selecionados) e
 * AND entre categorias diferentes (precisa casar em todas as categorias usadas).
 */
export const getFilteredQuestions = async (filters = {}) => {
    let questions = await getAllQuestions();

    // Normaliza um filtro (string ou array) para lista, removendo "todas"/"todos"/vazios.
    const toList = (v) =>
        (Array.isArray(v) ? v : v != null && v !== '' ? [v] : [])
            .filter((x) => x !== 'todas' && x !== 'todos');

    const disciplinas = toList(filters.disciplina);
    if (disciplinas.length) {
        questions = questions.filter(q =>
            disciplinas.some(d => q.disciplina?.toLowerCase().includes(d.toLowerCase()))
        );
    }

    const assuntos = toList(filters.assunto);
    if (assuntos.length) {
        questions = questions.filter(q => {
            const qAssuntos = getQuestionAssuntos(q).map(a => a.toLowerCase());
            return assuntos.some(a => qAssuntos.includes(a.toLowerCase()));
        });
    }

    const bancas = toList(filters.banca);
    if (bancas.length) {
        questions = questions.filter(q =>
            bancas.some(b => q.banca?.toLowerCase().includes(b.toLowerCase()))
        );
    }

    const anos = toList(filters.ano);
    if (anos.length) {
        questions = questions.filter(q =>
            anos.some(a => q.ano === a || String(q.ano) === String(a))
        );
    }

    const cargos = toList(filters.cargo);
    if (cargos.length) {
        questions = questions.filter(q =>
            cargos.some(c => q.cargo?.toLowerCase() === c.toLowerCase())
        );
    }

    const categorias = toList(filters.categoria);
    if (categorias.length) {
        questions = questions.filter(q =>
            categorias.some(c => getQuestionCategoria(q).toLowerCase() === c.toLowerCase())
        );
    }

    return questions;
};

/**
 * Obtém estatísticas. Se `categoria` for informada, considera apenas as questões
 * dessa categoria (ver CATEGORIAS).
 */
export const getQuestionsStats = async (categoria) => {
    const todas = await getAllQuestions();
    const allQuestions = categoria
        ? todas.filter(q => getQuestionCategoria(q) === categoria)
        : todas;
    const disciplinas = [...new Set(allQuestions.map(q => q.disciplina).filter(Boolean))];
    const assuntos = [...new Set(allQuestions.flatMap(q => getQuestionAssuntos(q)))];
    const bancas = [...new Set(allQuestions.map(q => q.banca).filter(Boolean))];
    const anos = [...new Set(allQuestions.map(q => q.ano).filter(Boolean))].sort((a, b) => b - a);
    const cargos = [...new Set(allQuestions.map(q => q.cargo).filter(Boolean))];

    return {
        total: allQuestions.length,
        disciplinas: disciplinas.sort(),
        assuntos: assuntos.sort(),
        bancas: bancas.sort(),
        anos,
        cargos: cargos.sort(),
    };
};

/**
 * Obtém assuntos de uma disciplina. Se `categoria` for informada, considera
 * apenas as questões daquela categoria.
 */
export const getAssuntosByDisciplina = async (disciplina, categoria) => {
    const base = await getQuestionsByDisciplina(disciplina);
    const questions = categoria
        ? base.filter(q => getQuestionCategoria(q) === categoria)
        : base;
    const assuntos = [...new Set(questions.flatMap(q => getQuestionAssuntos(q)))];
    return assuntos.sort();
};

/**
 * Obtém anos disponíveis
 */
export const getAvailableYears = async () => {
    const allQuestions = await getAllQuestions();
    const anos = [...new Set(allQuestions.map(q => q.ano).filter(Boolean))];
    return anos.sort((a, b) => b - a);
};

/**
 * Obtém bancas disponíveis
 */
export const getAvailableBancas = async () => {
    const allQuestions = await getAllQuestions();
    const bancas = [...new Set(allQuestions.map(q => q.banca).filter(Boolean))];
    return bancas.sort();
};

/**
 * Limpa o cache (útil para testes)
 */
export const clearQuestionsCache = () => {
    cachedAllQuestions = null;
};

export default {
    DISCIPLINAS,
    BANCAS,
    getAllQuestions,
    getQuestionsByDisciplina,
    getQuestionsByAssunto,
    getQuestionsByBanca,
    getFilteredQuestions,
    getQuestionsStats,
};
